import React, { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Label from '@components/inputs/text/Label';
import DropDownMenu, { IChoice } from '@components/inputs/DropDownMenu';
import { Country, getProvincesByCountry } from '@utils/constants/localisation';
import { textBoxStyle } from '@utils/styles/textboxStyle';
import { NavBar } from "@components/navigation/NavBar/NavBar";
import SubmitBtn from "@components/buttons/FormButtons/SubmitBtn";
import { OnboardingAddressState, OnboardingAddressAction } from './onboardingAddressReducer';

interface FlexiOwnAddressDetailsV2Props {
  navigateTarget: string;
  onboardingAddressState: OnboardingAddressState;
  onboardingAddressDispatch: React.Dispatch<OnboardingAddressAction>;
  country: Country;
}

export default function FlexiOwnAddressDetailsV2({
  navigateTarget,
  onboardingAddressState,
  onboardingAddressDispatch,
  country
}: FlexiOwnAddressDetailsV2Props) {
  const navigate = useNavigate();
  const streetNumberAndName = 'Street number and name';
  const city = 'City';
  const state = 'state';
  const postcode = 'Postcode';
  const dropDownPleaseSelect: IChoice = { label: '- please select -', value: '', enabled: false };

  const handleAddressInfoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.currentTarget.name) {
      case streetNumberAndName:
        onboardingAddressDispatch({ type: "SET_STREET", payload: e.currentTarget.value });
        break;
      case city:
        onboardingAddressDispatch({ type: "SET_CITY", payload: e.currentTarget.value });
        break;
      case state:
        onboardingAddressDispatch({ type: "SET_STATE", payload: e.currentTarget.value });
        break;
      case postcode:
        onboardingAddressDispatch({ type: "SET_POSTCODE", payload: e.currentTarget.value });
        break;
    }
  };

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    navigate(navigateTarget);
  };

  return (
    <>
      <NavBar pageTitle={"Address Details"} backAction={undefined} />
      <form style={{ margin: '2.5vh 2.5vw' }} onSubmit={onSubmit}>
        <p style={{ margin: '2.5vh 0' }}>
          Please review the customer's <strong>Residential address</strong> ensuring that each field is populated with the correct data.
        </p>

        <div style={{ margin: '2.5vh 0' }}>
          <Label text={'Unit/Street number and Street name'} styleCfg={{ largeFont: false, bold: false }} requiredFieldInd={true} />
          <input
            name={streetNumberAndName}
            style={textBoxStyle}
            required
            defaultValue={onboardingAddressState.street}
            onChange={handleAddressInfoChange}
          />
        </div>

        <div style={{ margin: '2.5vh 0' }}>
          <Label
            text={country === Country.AU ? 'City' : 'Town/City'}
            styleCfg={{ largeFont: false, bold: false }}
            requiredFieldInd={true}
          />
          <input
            name={city}
            style={textBoxStyle}
            required
            defaultValue={onboardingAddressState.city}
            onChange={handleAddressInfoChange}
          />
        </div>

        {country === Country.AU && (
          <div style={{ margin: '2.5vh 0' }}>
            <Label text={'State'} styleCfg={{ largeFont: false, bold: false }} requiredFieldInd={true} />
            <DropDownMenu
              menuName={state}
              defaultVal={
                onboardingAddressState.state
                  ? { label: onboardingAddressState.state, value: onboardingAddressState.state, enabled: true }
                  : dropDownPleaseSelect
              }
              required={true}
              choices={[dropDownPleaseSelect].concat(
                getProvincesByCountry(country).map((item: any) => ({ label: item, value: item, enabled: true }))
              )}
              onSelect={handleAddressInfoChange}
            />
          </div>
        )}

        <div style={{ margin: '2.5vh 0' }}>
          <Label text={'Postcode'} styleCfg={{ largeFont: false, bold: false }} requiredFieldInd={true} />
          <input
            name={postcode}
            style={textBoxStyle}
            required
            defaultValue={onboardingAddressState.postcode}
            onChange={handleAddressInfoChange}
          />
        </div>

        <SubmitBtn text={"Next"} />
      </form>
    </>
  );
}